module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.klass,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path, i) {
    return _c('path', _vm._b({
      key: ("path-" + i)
    }, 'path', path, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon, i) {
    return _c('polygon', _vm._b({
      key: ("polygon-" + i)
    }, 'polygon', polygon, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cffcddbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-awesome/components/Icon.vue
// module id = 1088
// module chunks = 1